import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import ViewDetailsModal from '../../components/ViewDetailModal/index.vue'
import OfferJobModal from '../../components/OfferJobsModal/index.vue'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      modalActive: false,
      modalPhoneActive: false
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    ViewDetailsModal,
    OfferJobModal
  },
  mounted () {
    // window.analytics.page('ExploreProfessional')
    window.analytics.identify('ExploreProfessional', {
      path: '/ExploreProfessional'
    })
  },
  methods: {
    uploadModal () {
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    verifyPhone () {
      this.modalPhoneActive = true
      document.body.classList.add('overlayBg')
    },
    close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
    },
    closePhone (bool) {
      if (!bool) this.modalPhoneActive = !this.modalPhoneActive
      else this.modalPhoneActive = null
      document.body.classList.remove('overlayBg')
    }
  }
}
